const windowSizes = {
    large: 1340,
    medium: 1048,
    small: 850,
    mobile: 560
}

export default windowSizes